var ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode["NETWORK_ERROR"] = "ERR_NETWORK";
  return ErrorCode;
}(ErrorCode || {});
export { ErrorCode };